import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75ebbd07")

_pushScopeId("data-v-75ebbd07")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-p" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_10 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_11 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_12 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_13 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_14 = { class: "fw-bold d-block fs-7 custom" }
const _hoisted_15 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_16 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_17 = { class: "menu-item-wrapper" }
const _hoisted_18 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(`${_ctx.$t('message.SUBSCRIPTION_ORDERS')}`), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          rows: _ctx.orders,
          padding: 5,
          pagination: _ctx.pagination,
          onHandleCurrentChange: _ctx.handleCurrentChange
        }, {
          "cell-name": _withId(({row:item}) => [
            (item?.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(item?.customer?.user?.name), 1))
              : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(item?.name), 1))
          ]),
          "cell-tenure": _withId(({row:item}) => [
            _createVNode("span", _hoisted_9, _toDisplayString(item?.tenure), 1)
          ]),
          "cell-last_order_date": _withId(({row:item}) => [
            _createVNode("span", _hoisted_10, _toDisplayString(item?.last_order_date), 1)
          ]),
          "cell-next_order_date": _withId(({row:item}) => [
            _createVNode("span", _hoisted_11, _toDisplayString(item?.next_order_date), 1)
          ]),
          "cell-status": _withId(({row:item}) => [
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.lastOrderplaced(item?.send_order)), 1)
          ]),
          "cell-origin": _withId(({row:item}) => [
            _createVNode("span", _hoisted_13, _toDisplayString(item?.smart_subscription_uuid ? 'Smart' : 'Shop'), 1)
          ]),
          "cell-created_at": _withId(({row:item}) => [
            _createVNode("span", _hoisted_14, _toDisplayString(item?.created_at), 1)
          ]),
          "cell-actions": _withId(({row:item}) => [
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                (_ctx.$can('view_order_detail'))
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleView(item)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange"])
      ])
    ])
  ]))
})